import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Alert } from '../../../../../base/components/Alert';
import { BreadcrumbLink, HeaderWithBreadcrumbs } from '../../../../../base/components/HeaderWithBreadcrumbs';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { VacancyView as VacancyViewComponent } from '../../components/VacancyView';
import { VacancySidebar } from '../../components/VacancySidebar';
import { vacancyActions } from '../../redux/slices/vacancySlice';
import { Loading } from '../../../../../base/enums';
import { Helmet } from '../../../../components/Helmet';

import './styles.scss';

export const VacancyView = () => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const loading = useAppSelector((state) => state.app.loading === Loading.App);
    const vacancyData = useAppSelector((state) => state.vacancy.vacancyData);

    useEffect(() => {
        dispatch(vacancyActions.getVacancyDataRequest(id));
    }, []);

    const onBackClick = () => {
        window.location.href = '/vacancy';
        return;
    };

    const breadcrumbs: BreadcrumbLink[] = [
        {
            text: __t('Главная'),
            url: '/',
        },
    ];

    if (loading || !vacancyData) {
        return null;
    }

    const { isActive, isDraft, name } = vacancyData;

    return (
        <>
            <Helmet pageName={name} />
            <HeaderWithBreadcrumbs
                links={breadcrumbs}
                current={name}
                title={__t('Назад к моим вакансиям')}
                backLinkText={__t('Назад к моим вакансиям')}
                onBackClick={onBackClick}
            />
            <div className='vacancy-view-page'>
                <div className='razem-app__wrapper vacancy-view-page__flex-wrap'>
                    {!isActive && !isDraft && (
                        <Alert
                            text={__t('Вакансия закрыта')}
                            type='warn'
                            icon='circle-exclamation-regular'
                            className='vacancy-view-page__alert'
                        />
                    )}

                    {!isActive && isDraft && (
                        <Alert
                            text={__t('Черновик')}
                            type='warn'
                            icon='circle-exclamation-regular'
                            className='vacancy-view-page__alert'
                        />
                    )}

                    <div className='vacancy-view-page__main'>
                        <VacancyViewComponent />
                    </div>

                    <aside className='vacancy-view-page__sidebar'>
                        <VacancySidebar />
                    </aside>
                </div>
            </div>
        </>
    );
};
